import {Component, EventEmitter, OnInit, Output, Input, signal} from '@angular/core';
import {RequestService} from "../../../../services/api/v1/request.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CustomMessageService, UtilService} from "library";
import {forkJoin} from "rxjs";
import {HttpStatusCode} from "@angular/common/http";
import {SalesWorkflowSteps, SalesWorkflow} from "projects/store/src/app/enums";
import {MacroFlowService} from "projects/store/src/app/services/api/v1/macro-flow.service";



@Component({
  selector: 'app-sales-accept-credit-conditions-general',
  templateUrl: './sales-accept-credit-conditions-general.component.html',
  styles: [
  ]
})
export class SalesAcceptCreditConditionsGeneralComponent implements OnInit {
  @Input() request: any;
  @Input() showChangeProductButton: boolean = true;
  requestId: string;
  flowCode: string;
  categoryList: any[] = [];
  isTopUpLoan: boolean = false;

  data = signal<any>({});
  readonly categoryCode = this.route.snapshot.params['category_code'];

  @Output() nextStepEvent = new EventEmitter();
  @Output() gotoStepEvent = new EventEmitter();


  constructor(private requestService: RequestService,
              private route: ActivatedRoute,
              private router: Router,
              private utilService: UtilService,
              public macroFlowService: MacroFlowService,
              private customMessageService: CustomMessageService) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.flowCode = this.route.snapshot.params['flow_code'];
    this.request = this.requestService.request;
  }

  ngOnInit() {
    this.load();
    this.isTopUpLoan = this.request.top_up_loan ?? false;
    this.data.set(this.requestService.request);
  }

  load() {
    this.utilService.enablePageLoading();

    this.requestService.getCategoriesList(this.requestId).subscribe({
      next: (resp) => {

        if (resp.status === HttpStatusCode.Ok) {
          this.categoryList = resp.body.data.list;
        }else {
          this.customMessageService.responseError();
        }

        this.utilService.disablePageLoading();
      },
      error: (error) => {
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      },
      complete: () => {
        this.utilService.disablePageLoading();
      }
    });
  }

  extractCategoryIcon(categoryID: string){
    return this.categoryList.find((category) => category.id === categoryID)?.icon_url;
  }

  onNextStep() {
    this.utilService.enablePageLoading();
    this.nextStepEvent.emit();
  }

  onGotoStep(categoryId: string, stepCode: string) {
    this.utilService.enablePageLoading();
    this.gotoStepEvent.emit({ flowCode: this.flowCode, stepCode, categoryId });
  }

  frecuencyText(frecuency: number) {
    return this.utilService.getFrequencyDescription(frecuency);
  }

  hasAdditionalProduct(): boolean {
    return !!this.request?.additional_product;
  }

  getAdditionalProduct(): any {
    return this.request?.additional_product;
  }

  getAdditionalProductNetAmount(): number {
    const additionalProduct = this.getAdditionalProduct();
    if (!additionalProduct) {
      return 0;
    }

    if (additionalProduct.net_amount !== undefined && additionalProduct.net_amount !== null) {
      return Number(additionalProduct.net_amount) || 0;
    }

    const amount = Number(additionalProduct.amount) || 0;
    const discountPct = Number(additionalProduct.discount_pct) || 0;
    return amount * (1 - discountPct / 100);
  }

  getProductsSubtotal(): number {
    return Number(this.request?.quotes?.prices?.selected) || 0;
  }

  getMainProductAmount(): number {
    const selectedPrice = this.getProductsSubtotal();
    if (!this.hasAdditionalProduct()) {
      return selectedPrice;
    }

    return selectedPrice - this.getAdditionalProductNetAmount();
  }

  getInstallmentAmount(): number {
    return Number(this.request?.quotes?.installment?.selected) || 0;
  }

  getFinancedTotalAmount(): number {
    return this.getProductsSubtotal() - this.getInstallmentAmount();
  }

  protected readonly SalesWorkflowSteps = SalesWorkflowSteps;
  protected readonly SalesWorkflow = SalesWorkflow;

}
